import { z } from 'zod';
import { INVOICE_INTEGRATION_STATUSES } from './invoices.js';
export const INTEGRATION_STATUSES = [
    'requested',
    'pending',
    'awaiting_authorization',
    'credentials_pending',
    'connection_testing',
    'connected',
    'failed',
    'suspended',
    'disabled',
    'revoked',
];
export const integrationStatusSchema = z.enum(INTEGRATION_STATUSES);
export const requestIntegrationSchema = z.object({
    taxpayerProfileId: z.uuid(),
    contactEmail: z.email().nullish(),
    /** The requester confirms they are authorised to act for this taxpayer. */
    confirmAuthority: z.literal(true, { error: 'Confirm that you are authorised to act for this taxpayer.' }),
});
export const integrationAvailabilitySchema = z.object({
    mode: z.enum(['disabled', 'mock', 'http']),
    available: z.boolean(),
    simulated: z.boolean(),
    environment: z.enum(['sandbox', 'production']).nullable(),
    providerCode: z.string().nullable(),
    /** Plain-language reason shown when `available` is false. */
    reason: z.string().nullable(),
});
export const businessIntegrationSchema = z.object({
    id: z.uuid(),
    taxpayerProfileId: z.uuid(),
    taxpayerName: z.string(),
    providerCode: z.string(),
    environment: z.enum(['sandbox', 'production']),
    simulated: z.boolean(),
    status: integrationStatusSchema,
    nrsBusinessId: z.string().nullable(),
    nrsServiceId: z.string().nullable(),
    requestedAt: z.string().nullable(),
    enabledAt: z.string().nullable(),
    lastConnectionTestAt: z.string().nullable(),
    lastSyncedAt: z.string().nullable(),
    lastErrorCode: z.string().nullable(),
    lastErrorMessage: z.string().nullable(),
    createdAt: z.string(),
});
export const submitInvoiceSchema = z.object({});
export const nrsMappingInputSchema = z.object({
    productServiceId: z.uuid(),
    hsnCode: z.string().trim().max(40).nullish(),
    productCategory: z.string().trim().max(100).nullish(),
    isicCode: z.string().trim().max(20).nullish(),
    serviceCategory: z.string().trim().max(100).nullish(),
    taxCategoryId: z.uuid(),
});
export const nrsMappingSchema = z.object({
    id: z.uuid(),
    productServiceId: z.uuid(),
    productName: z.string(),
    itemCode: z.string(),
    lineType: z.enum(['goods', 'service']),
    hsnCode: z.string().nullable(),
    productCategory: z.string().nullable(),
    isicCode: z.string().nullable(),
    serviceCategory: z.string().nullable(),
    taxCategoryId: z.uuid(),
    syncStatus: z.enum(['pending', 'synced', 'failed']),
    lastSyncedAt: z.string().nullable(),
    lastErrorMessage: z.string().nullable(),
});
export const invoiceIntegrationStatusResponseSchema = z.object({
    available: z.boolean(),
    integrationId: z.uuid().nullable(),
    connectionStatus: integrationStatusSchema.nullable(),
    canSubmit: z.boolean(),
    /** Why submission is not currently possible, in business language. */
    blockedReason: z.string().nullable(),
    submission: z
        .object({
        id: z.uuid(),
        status: z.enum(INVOICE_INTEGRATION_STATUSES),
        irn: z.string().nullable(),
        qrPayload: z.string().nullable(),
        clearanceStatus: z.string().nullable(),
        exchangeStatus: z.string().nullable(),
        submittedAt: z.string().nullable(),
        lastSyncedAt: z.string().nullable(),
        lastErrorMessage: z.string().nullable(),
        simulated: z.boolean(),
    })
        .nullable(),
});
//# sourceMappingURL=integrations.js.map